// extracted by mini-css-extract-plugin
export default {"primary":"Typography_primary__7POCB","type":"Typography_type__li3Op"};